/* tslint:disable */
/* eslint-disable */

/**
 * What one Verification of Payee came to:
 * - `match`: the name matches the account holder's (Nordea RCVC).
 * - `close_match`: the name partly differs; `holder_name` is the
 *   holder's name as the bank knows it (RVMC).
 * - `no_match`: the name is not the account holder's (RVNM).
 * - `not_possible`: the bank could not verify the pair (RVNA), or the
 *   check ended in a technical error.
 * - `rejected`: Nordea refused the request as invalid, such as one
 *   without a name; the input needs fixing.
 */
export enum VopOutcome {
  Match = 'match',
  CloseMatch = 'close_match',
  NoMatch = 'no_match',
  NotPossible = 'not_possible',
  Rejected = 'rejected'
}
